module.exports = "img/files.007db3a.png";